import { Component, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { GuidGenerator, QoutationTableComponent } from 'ncache-common-library';
import { finalCostModel, QuotationEnvironmentsModel, subscriptionPeriodModel } from 'ncache-common-library';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { POPUP_MESSAGES } from 'src/app/Util/constants';
import Helper from 'src/app/Util/helper';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/common-layout/popup/popup.component';
import { FormPersistenceService } from 'src/app/paid-subscription/services/form-persistence.service';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { HttpErrorResponse } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { QuotationService } from 'src/app/paid-subscription/services/quotation.service';
import { UpdatedBy } from 'src/app/enums/environments.enum';
import { QuotationPathEnum, QuotationStatus, QuotationType } from 'src/app/enums/quotation.enum';
import { map, switchMap } from 'rxjs';
import { NCacheSubscription } from 'src/app/interfaces/subscription.interface';
import { environment } from 'src/environments/environment.prod';
import { CompleteUserDetails } from 'src/app/models/user.model';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { DateHelper } from 'src/app/Util/date-helper';
import { CommonLayoutModule } from "../../../../../../common-layout/common-layout.module";



interface companyDateInterface{
  [key: string]: string;
}


@Component({
  selector: 'app-newquotation',
  standalone: true,
  imports: [
    QoutationTableComponent,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    CommonLayoutModule
],
styleUrls: ['./quotationpreview.component.sass'],
  templateUrl: './quotationpreview.component.html',
})
export class QuotationpreviewComponent implements OnDestroy {

  @ViewChild(QoutationTableComponent) quotationTable!: QoutationTableComponent;
  // @ViewChild(GenericmodalComponent) genericModal!: GenericmodalComponent;
  showToast: boolean = false;
  toastTitle: string = '';
  toasType: 'success' | 'danger' | 'warning' | 'information' = 'success';
  successfulRegistrationModalStepOne: any;
  successfulQuotationModal:any
  quotationConfirmationRef: NgbModalRef;
  submitQuotationFunction : () => void

quotationExistingEnvs:any =[]
nextHeader : string = ''
  isPreview: boolean = true;
  subscriptionDetails:any = null
  isSupportQuotation: boolean = false;
  isQuotationModified: boolean = false;
  quotationCategoryName: string = '';
  subscriptionId: string = '';
  quotationId: string = '';
  cloudProvider: string = '';
  cloudPlan: string = '';
  userEmail: string = '';
  fetchedQuotation: any = {};
  CompanyTitle = 'Company ';
  contactTitle = 'Contact ';
  salesPersonData =  {}
  companyData: companyDateInterface = {};
  isQuotationThroughParamas = false
  subscriptionData : subscriptionPeriodModel = new subscriptionPeriodModel()
  title: string
  disablePreviousBtn:boolean = false
  confirmBtnTitle:string = 'Submit'
  faCloud = faCloud
  quotationPeriodType:string = ''
  quotationPeriod:string
  fromPath:string = ''
  userDetails: CompleteUserDetails;
  quotationType:string=''
  constructor(
    private route: Router,
    private readonly environmentSvc: EnvironmentService,
    private readonly modal: NgbModal,
    private notificationService:CloudNotificationService,
    private formService:FormPersistenceService,
    private localStorageService:LocalStorageService,
    private routeQuery:ActivatedRoute,
    private quotationService:QuotationService,
    private cloudService: CloudProfileService,
  ) {}

  private getSubscriptionId(){
    this.subscriptionId =  this.localStorageService.getItemSessionStorage(StorageKeys.SubscriptionId).replace(/\\/g, '')
    return this.subscriptionId
  }
  ngOnDestroy(): void {
      quotationGlobalState.resetQuotationId()
  }



  checkIfsubscriptionNonHosted(){
    let isHosted = false
    if(this.subscriptionDetails?.planType)
    {
      isHosted = Helper.isPlanNonHosted(this.subscriptionDetails?.planType)
    }
    return isHosted
  }


  private getQuotationIdFromQueryParams(){

    this.routeQuery.queryParams.subscribe(params => {
      if(Object.keys(params).length > 0){
      const param1 = params['quotationId'];
      this.fromPath = params['frompath']
      this.quotationId = param1
      this.initializeProperties()
      }
      else{
        this.initalizeSubmitButton(this.openQuotationConfirmationPopup)
      }
    });
  }

  private initializeProperties(){
    this.getQuotationDetails(this.quotationId)
    this.initalizeSubmitButton(this.openQuotationConfirmPopup)
    this.isQuotationThroughParamas = true
    this.toggleConfirmBtnName('Confirm')
    if(this.fromPath === QuotationPathEnum.BUY_NCACHE){
      this.togglePreviousBtn(false)
    }
    else if(this.fromPath === QuotationPathEnum.EMAIL_LINK){
      this.togglePreviousBtn(true)
    }
  }

  private togglePreviousBtn(val:boolean){
    this.disablePreviousBtn = val
  }

  private toggleConfirmBtnName(val:string){
    this.confirmBtnTitle = val
  }


  checkIfQuotationMidYear(){
    return this.formService.isMidYear
  }


  previewData: any = [];
  previewFinalCost :any

  modalTitle :string ="Quotation Submition"
  modalDescription :string ="Are you sure you want to approve this Quotation ?  This action cannot be undone!"

  private getQuotationDetails(id:string){
    this.environmentSvc.getQuotationDetailsById(id).subscribe({
      next:(res)=>{
        if(res == null) {
          this.notificationService.createToastNotification('get-subscription-details', Helper.resolveErrorMessage("Invalid QuotationID"), CloudNotificationStyle.danger);
          this.route.navigate([environment.routes.environment])
          return
        }
        this.previewData = res.quotationEnvironmentsInfo
        this.updateFinalCosts(res)
        this.fetchedQuotation = res;
        this.shuffleNewServerWithTotal(this.previewData,this.fetchedQuotation)
        this.quotationType = res.type
        this.setPageTitle(res.type,res.subscription)
      },
      error:(err)=>{
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      }
    })
  }


  getQuotationStatus(){
    return  (this.fetchedQuotation?.updatedBy == UpdatedBy.Customer && this.fetchedQuotation?.status == QuotationStatus.Approve) || (this.fetchedQuotation?.updatedBy == UpdatedBy.Accounts && this.fetchedQuotation?.status == QuotationStatus.Active) || (this.fetchedQuotation?.status == QuotationStatus.Reject)
  }


  private shuffleNewServerWithTotal(previewData:any,fetchedQuotation:any){
    if(fetchedQuotation?.status == QuotationStatus.Active && fetchedQuotation?.updatedBy == UpdatedBy.Accounts){
      previewData.forEach(element => {
        [element.totalReservedServerCount,element.existingReservedServerCount] = [element.existingReservedServerCount,element.totalReservedServerCount]
      });
    }
  }



  private getExistingEnvironments(allQuotationEnvironments:any[]){
    if(this.formService.isMidYear){
      this.environmentSvc.getQuotationExistingEnvironment(this.getSubscriptionId()).subscribe({
        next:(res)=>{
          this.quotationExistingEnvs = res
        },
        error:(err)=>{
          this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
        }
      })
    }
  }

  private initalizeSubmitButton(callback:()=>void){
    this.submitQuotationFunction = callback
  }

  private updateFinalCosts(res:any){

    let costs = {
      totalSoftwareCost:res.totalSoftwareCost || 0,
      totalInfratStructureCost:res.totalInfraCost || 0,
      _24X7Cost: res.total24X7Price || 0,
      totalDiscount:res.discount  || 0,
      totalCost:res.totalCost  || 0,
      absoluteCost: res.totalCost || 0
    }
    this.previewFinalCost = costs
  }

  handleFinalCost(event: any) {
    quotationGlobalState.updateFinalCost(event);
  }


  //Needs to be called on each page we cant store it in service or global state becuase upon refreshing it will get lost
  //so it needs to be called each time page is refershed
  private getSubscriptionDetails(): void {

    this.formService.getSubscriptionDetails(this.subscriptionId)
    .pipe(switchMap((subscription) => {
        return this.quotationService.getQuotationPeriod(this.getSubscriptionId()).pipe(
          map((quotationPeriod) => ({
            subscription,
            quotationPeriod
          }))
        );
      })
    )
    .subscribe({
      next: ({ subscription, quotationPeriod }) => {
        this.quotationPeriod = quotationPeriod;
        this.subscriptionDetails = subscription
        if(this.quotationId == '' || this.quotationId == undefined){
          this.setPageTitle(quotationPeriod,subscription)
        }
      },
      error: (err: HttpErrorResponse) => {
        this.notificationService.createToastNotification('get-subscription-details', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger);
      }
    });
  }

  private setPageTitle(quotationPeriod:QuotationType,subscription:NCacheSubscription){

     this.title = `Request Quotation (${subscription.vendor})`;
    this.nextHeader = `${subscription.planTitle}`
  }

  private getReadableQuotationPeriod(quotationPeriod:QuotationType){
    switch(quotationPeriod){
      case QuotationType.MidYear:
        return "Mid Year"
      case QuotationType._24x7:
        return "24x7"
      case QuotationType.Annual:
        return "Annual"
      defualt:
        "Awaiting Quotation"
    }
  }
  ngOnInit(): void
  {
    this.getSubscriptionId()
    this.getQuotationIdFromQueryParams()
    this.getSubscriptionDetails()
    this.getUserData();
    quotationGlobalState.getAllGlobalEnvironments().subscribe(
      (allEnvironments: any) =>
      {
        this.previewData = allEnvironments;
        this.getExistingEnvironments(allEnvironments)
      }
    );
    quotationGlobalState.getFinalCost().subscribe(env =>
    {
      this.previewFinalCost =  env
    })

    quotationGlobalState.getQuotationCategory().subscribe(cat =>{
      this.quotationCategoryName = cat
    })


    quotationGlobalState.geSubscriptionPeriod().subscribe(cat=>{
      this.subscriptionData = cat
    })


    quotationGlobalState.getQuotationId().subscribe(env=>{
      this.quotationId = env
      if(this.quotationId != undefined && this.quotationId != ''){
      this.getQuotationDetails(env)
      this.initalizeSubmitButton(this.openQuotationConfirmPopup)
      }
    })

    quotationGlobalState.getSubscriptionId().subscribe(env=>{
      this.subscriptionId = env
    })

    quotationGlobalState.getQuotationCategory().subscribe(env=>{
      this.quotationCategoryName = env
    })

    quotationGlobalState.getCloudProvider().subscribe(env=>{
      this.cloudProvider = env
    })

    quotationGlobalState.getPlanEdition().subscribe(env=>{
      this.cloudPlan = env
    })

    quotationGlobalState.geIsQuotationModified().subscribe(env=>{
      this.isQuotationModified = env
    })

    const routeState = history.state;

    if (routeState !== null)
    {
      this.isSupportQuotation = routeState.is24x7Quotation || false;
      // this.getSalesPersonDetails(this.userEmail)
    }

    if (this.isQuotationModified)
      {
        this.modalDescription = "Are you sure you want to submit this Quotation to Client ?  This action cannot be undone!"
      }

  }

  isHiddenColumns(fieldName: string): boolean {
    if (this.isSupportQuotation) {
      const hiddenColumns = [
        'Infrastructure',
        'Infrastructure.Hourly',
        'Infrastructure.1-Year Price',
        'Infrastructure.1-Year Cost',
        'SubTotal',
      ];
      return hiddenColumns.includes(fieldName);
    }
    return false;
  }
  handlePreviewEnviromentsArray(event: any) {

    this.route.navigate(['/sales/newquotation'], {
    });

  }


  generateQuotation()
  {
    if (this.quotationTable)
    {
      this.quotationTable.generateQuotation()
    }
  }

  togglePreviousButton(){
    if(this.fromPath == "buyncache"){
      return true
    }
    return false
  }


  back()
  {
    if(this.formService.customQuotationId != ''){
      this.route.navigate(['/newquotation']);
      return
    }
    if (this.quotationTable)
    {
      this.route.navigate(['/createquotation'], {});
    }
  }

  private navigateToNewQuotation(){
    this.route.navigate(['/newquotation'])
  }


  openQuotationConfirmationPopup() {
    this.quotationConfirmationRef = this.modal.open(PopupComponent)
    Helper.configurePopup(this.quotationConfirmationRef, {
      title: POPUP_MESSAGES.quotation__Request_Confirmation.title,
      message: POPUP_MESSAGES.quotation__Request_Confirmation.message,
      btnTitle: POPUP_MESSAGES.quotation__Request_Confirmation.btnTitle,
      viewCancelBtn: true,
      viewCrossBtn: false,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.quotationConfirmationRef.close();
          this.onQuotationConfirm();
        }
      }
    });
  }

  showQuotationSuccessfulPopup() {
    this.successfulRegistrationModalStepOne = this.modal.open(PopupComponent,{backdrop:"static",keyboard:false})
    Helper.configurePopup(this.successfulRegistrationModalStepOne, {
      title: POPUP_MESSAGES.quotation_Req_Successful.title,
      message: POPUP_MESSAGES.quotation_Req_Successful.message,
      salesMessage: POPUP_MESSAGES.quotation_Req_Successful.salesMessage,
      salesLink: POPUP_MESSAGES.quotation_Req_Successful.salesLink,
      btnTitle: POPUP_MESSAGES.quotation_Req_Successful.btnTitle,
      viewSalesMessage: true,
      viewCrossBtn: false,
      linkMessage: POPUP_MESSAGES.quotation_Req_Successful.linkMessage,
      viewCancelBtn: false,
      viewLink: true,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.successfulRegistrationModalStepOne.close();
          this.navigateToDashBoard()
        }
      }
    });
  }


  private navigateToDashBoard(){
    this.route.navigate(['/subscription/dashboard'])
  }

private checkIf24x7Enabled(){
  if (this.previewFinalCost?._24X7Cost != 0 ){
    return true
  }
  return false
}

  onQuotationConfirm() {
    this.checkIf24x7Enabled()
    let req = {
      "SubscriptionID": this.subscriptionId,
      "QuotationEnvironmentsInfo": this.previewData,
      "Type":this.quotationPeriod,
      "Enable24x7":this.checkIf24x7Enabled()
    };
    this.environmentSvc.submitQuotationRequest(req).subscribe((req) => {
      this.showQuotationSuccessfulPopup();
    },
    (err) => {
      this.notificationService.createToastNotification('create-quotation-error', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
    });
  }

  private openQuotationConfirmPopup() {
    this.quotationConfirmationRef = this.modal.open(PopupComponent)
    Helper.configurePopup(this.quotationConfirmationRef, {
      title: POPUP_MESSAGES.quotation_confirm_after_sales_approval.title,
      message: POPUP_MESSAGES.quotation_confirm_after_sales_approval.message,
      viewCancelBtn: true,
      viewCrossBtn: false,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.quotationConfirmationRef.close();
          this.updateQuotationStatus()
        }
      }
    });
  }

  private getUserData() {
    this.cloudService.getCompleteUserDetails().subscribe({
      next: (res) => {
        this.userDetails = res;
      },
      error: (err) => {
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      },
    });
  }

  quotationApprovedMessage(){
    if (this.getQuotationStatus()){
      let updatedBy:string = UpdatedBy.Accounts
      if(this.fetchedQuotation?.updatedBy == UpdatedBy.Customer){
        updatedBy = UpdatedBy.Customer
      }
      return `Quotation is already approved By ${updatedBy} on ${DateHelper.convertToReadableDate(this.fetchedQuotation?.updatedAt)}`
    }
    return '';
  }



  private quotationData()
  {
    let quotationData =
    {
      QuotationId: this.fetchedQuotation.quotationId,
      QuotationStatus: this.fetchedQuotation?.updatedBy === UpdatedBy.Sales ? QuotationStatus.Approve : QuotationStatus.Request ,
      UpdatedBy:UpdatedBy.Customer
    }
    return quotationData;
  }

  private updateQuotationStatus(){
    this.environmentSvc.updateQuotationStatus(this.quotationData()).subscribe({
      next:(res)=>{
        this.showQuotationSuccessful()
      },
      error:(err)=>{
        this.notificationService.createToastNotification("Self Buy",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      }
    })
  }

  showQuotationSuccessful() {
    this.successfulQuotationModal = this.modal.open(PopupComponent,{
      backdrop: 'static',
      keyboard: false
    })
    Helper.configurePopup(this.successfulQuotationModal, {
      title: POPUP_MESSAGES.quotation_req_success_message.title,
      message: POPUP_MESSAGES.quotation_req_success_message.message,
      salesLink: POPUP_MESSAGES.quotation_req_success_message.salesLink,
      salesMessage:POPUP_MESSAGES.quotation_req_success_message.salesMessage,
      btnTitle: POPUP_MESSAGES.quotation_req_success_message.btnTitle,
      linkMessage: POPUP_MESSAGES.quotation_req_success_message.linkMessage,
      viewSalesMessage: true,
      viewCrossBtn: false,
      viewCancelBtn: false,
      viewLink: true,
      valueProcessor: (receivedConfirmation) => {
        if (receivedConfirmation) {
          this.successfulQuotationModal.close();
          this.navigateToDashBoard();
        }
      }
    });
  }

  toggleButtons(){
    if(this.isTransactionLink()){
      return false
    }
    return true
  }

  isTransactionLink():boolean{
    return this.fromPath == QuotationPathEnum.TRANSACTION_LINK
  }
}
